// DPD merch robot (2026-08-28, ratified by Zac): tag autocomplete queries with the
// rule context "autocomplete" so Algolia Rules can curate the search overlay
// (robot "Trending Now") WITHOUT touching collection pages. Defensive: any failure
// leaves the query untouched.
// INSTALL: save as assets/dpd-algolia-context-hook.js and add to layout/theme.liquid
// before </body>:  <script src="{{ 'dpd-algolia-context-hook.js' | asset_url }}" defer="defer"></script>
document.addEventListener('algolia.hooks.initialize', function () {
  try {
    window.algoliaShopify.hooks.registerHook('beforeAutocompleteConfigurationOptions', function (config) {
      try {
        if (config && Array.isArray(config.queries)) {
          config.queries.forEach(function (q) {
            if (!q) return;
            if (q.indexName && q.indexName.indexOf('query_suggestions') !== -1) return;
            q.params = q.params || {};
            var rc = Array.isArray(q.params.ruleContexts) ? q.params.ruleContexts.slice() : [];
            if (rc.indexOf('autocomplete') === -1) rc.push('autocomplete');
            q.params.ruleContexts = rc;
          });
        }
      } catch (e) {}
      return config;
    });
  } catch (e) {}
});
